function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M76,9.9v18.3V32v0.1c0,3.4-2.2,6.2-5.3,7.3c-0.8,0.3-1.3,1-1.3,1.9l1.3,45.4c0,2.3-1.8,4.2-4.2,4.2h-0.1 c-2.3,0-4.2-1.8-4.2-4.2l1.3-45.4c0-0.9-0.5-1.7-1.3-1.9c-3.1-1-5.3-3.9-5.3-7.3V32v-3.8V9.9c0-0.8,0.6-1.3,1.3-1.3l0,0 c0.8,0,1.3,0.6,1.3,1.3v17c0,0.8,0.6,1.3,1.3,1.3l0,0c0.8,0,1.3-0.6,1.3-1.3v-17c0-0.8,0.6-1.3,1.3-1.3l0,0c0.8,0,1.3,0.6,1.3,1.3 v17c0,0.8,0.6,1.3,1.3,1.3l0,0c0.8,0,1.3-0.6,1.3-1.3v-17c0-0.8,0.6-1.3,1.3-1.3l0,0c0.8,0,1.3,0.6,1.3,1.3v17 c0,0.8,0.6,1.3,1.3,1.3l0,0c0.8,0,1.3-0.6,1.3-1.3v-17c0-0.8,0.6-1.3,1.3-1.3l0,0C75.4,8.5,76,9.1,76,9.9z M46.8,24.2 c0-8.7-5.1-15.8-11.3-15.8s-11.3,7-11.3,15.8c0,6.7,3.1,12.6,7.4,14.8c0.6,0.4,1,1,1,1.8l-1.4,46.1c0,2.3,1.8,4.2,4.2,4.2h0.1 c2.3,0,4.2-1.8,4.2-4.2l-1.2-46.1c0-0.8,0.4-1.4,1-1.8C43.8,36.8,46.8,30.9,46.8,24.2z"
});

function SvgMealPlan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMealPlan);
export default __webpack_public_path__ + "static/media/MealPlan.b1e4dfd0.svg";
export { ForwardRef as ReactComponent };